import { http } from '@/plugins/axios'
import * as qiniu from 'qiniu-js';
import {Notify} from "vant";

// 接口环境
const env = 'development'

// 配置接口环境对应域名 production为线上地址(必须) development为测试地址
const apisURL = {
  production: 'https://api.up-petroleum.com/api/v1/',
  development: 'https://apitest.up-petroleum.com/api/v1/',
}

// 生成接口baseUrl 生产环境强制为production
const baseURL = process.env.NODE_ENV == "production" ? apisURL['production'] : apisURL[env]

/**
 * 获取七牛云token
 * @returns {Promise<unknown>}
 */
function getQiniuToken() {
  return new Promise((resolve, reject) => {
    http({ method: 'get', url: 'qiniuToken', myBaseUrl: baseURL, isShowLoading:false }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  });
}

export {
  getQiniuToken,
}
